import React from "react"
import { Title, InsetWrap } from "@citydna/common"
import { Divider } from "@material-ui/core"
import { useHistory } from "react-router-dom"

import { WarningPanel } from "../common/WarningPanel"

import { GroupsAndLayersList } from "./GroupsAndLayersList"
import { usePortalGroups } from "./usePortalGroups"

export const BrowseFeatureLayers = () => {
  /** Get groups with featureLayers from esri */
  const [groups, , status] = usePortalGroups()

  /** Redirect on select */
  const history = useHistory()
  const handleItemClick = (result: __esri.FeatureLayer) => {
    history.push(`/layers/${result.id}`)
  }

  return (
    <InsetWrap>
      <Title
        primary="Collections"
        secondary="Select a feature collection to manage"
      />
      <Divider />
      {(!groups || groups.length === 0) && status === "resolved" ? (
        <WarningPanel
          warning="You're not part of any groups yet. Please ask the GIS team to add you to one."
          maxWidth={375}
          display="inline-block"
          mt={2}
        />
      ) : (
        <GroupsAndLayersList groups={groups} onClick={handleItemClick} />
      )}
    </InsetWrap>
  )
}
